import { render, staticRenderFns } from "./DocumentsModalList.vue?vue&type=template&id=32e80dbc&"
import script from "./DocumentsModalList.vue?vue&type=script&lang=js&"
export * from "./DocumentsModalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports